import forDevice from '../../hoc/for-device';
import ReplyMobile from './reply-mobile';
import ReplyDesktop from './reply-desktop';

export const Reply = forDevice(ReplyMobile, ReplyDesktop);
